// App-update store — pwa/register.ts WRITES here; components only READ.
//
// Deliberately separate from lib/offline's sync-status store: a waiting service
// worker is about the APP BUILD, queued entries are about DATA, and collapsing
// them into one badge would put "3 queued" and "new version ready" behind the
// same control when they need different actions from the user.
import { create } from 'zustand';

export interface AppUpdateState {
  /** A new service worker is installed and waiting to take over. */
  updateReady: boolean;
  /** The user accepted; skipWaiting is posted and the reload is imminent. */
  applying: boolean;

  // Registration-only writers.
  setUpdateReady: (updateReady: boolean) => void;
  setApplying: (applying: boolean) => void;
}

export const useAppUpdate = create<AppUpdateState>(set => ({
  updateReady: false,
  applying: false,

  setUpdateReady: updateReady => set({ updateReady }),
  setApplying: applying => set({ applying })
}));
